import { render, staticRenderFns } from "./df-page-account-card.vue?vue&type=template&id=18234df0&"
import script from "./df-page-account-card.ts?vue&type=script&lang=js&"
export * from "./df-page-account-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports